import React from "react"
import { Link } from "gatsby"

const PLink = ({ title, link, date }) => (
  <div>
    <Link
      to={link}
      style={{
        color: "#925FCF",
        display: `inline-block`,
        marginBottom: "12px",
      }}
    >
      {title}
    </Link>
    <span style={{ color: `#bbb`, fontSize: `0.82rem` }}> — {date}</span>
  </div>
)

export default PLink
